import {CommonModule} from '@angular/common';
import {NgModule} from '@angular/core';
import {SharedModule} from '../../shared/modules/shared.module';
import {MainPageRoutingModule} from './main-page-routing.module';
import {MainPageComponent} from './main-page.component';
import { PopularDoctorComponent } from './popular-doctor/popular-doctor.component';
import { BlogQuickViewComponent } from './blog-quick-view/blog-quick-view.component';
import { HomeBannerSliderComponent } from './home-banner-slider/home-banner-slider.component';
import {MatButtonToggleModule} from "@angular/material/button-toggle";
import { ShortenTextPipe } from 'src/app/pipes/text-shortener.pipe';

@NgModule({
  declarations: [MainPageComponent, PopularDoctorComponent, HomeBannerSliderComponent,ShortenTextPipe],
  imports: [
    CommonModule,
    MainPageRoutingModule,
    SharedModule,
    MatButtonToggleModule
  ]
})

export class MainPageModule {
}
